export default "__VITE_ASSET__IOq8GnJn__"